var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislikedOld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9304 3.48926C19.0985 3.31813 19.0052 3.02848 18.7685 3.00624C18.5232 2.9832 18.2749 2.97143 18.0243 2.97143C15.9322 2.97143 14.0913 3.97003 12.7703 5.26215C11.4492 3.97003 9.60831 2.97143 7.51622 2.97143C3.45767 2.97143 0 6.06068 0 10.0728C0 12.8407 1.27315 15.1709 2.9605 17.1012C3.27227 17.4579 3.6008 17.8039 3.94168 18.1396C4.11109 18.3064 4.38018 18.3012 4.54686 18.1315L18.9304 3.48926Z",
    fill: "#1a1a1a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.82863 24.0483L1.78006 24.0978C1.35259 24.5329 1.35259 25.2385 1.78006 25.6736C2.20752 26.1088 2.90058 26.1088 3.32805 25.6736L7.69187 21.2313C8.05624 21.4933 8.41791 21.7465 8.77277 21.991L12.1567 24.3228C12.5273 24.5781 13.0133 24.5781 13.3838 24.3228L16.7678 21.991C18.729 20.6396 20.8985 19.0249 22.58 17.1012C24.2674 15.1709 25.5405 12.8407 25.5405 10.0728C25.5405 8.14701 24.7439 6.43382 23.4666 5.17284L26.6794 1.9022C27.1069 1.46705 27.1069 0.761522 26.6794 0.326367C26.265 -0.0954782 25.601 -0.108382 25.1714 0.287656L1.86859 24.0096C1.85551 24.0229 1.84219 24.0358 1.82863 24.0483Z",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikedOld);
export default __webpack_public_path__ + "static/media/disliked_old.afaa96c9b0da2c9469a4a19330aba9e8.svg";
export { ForwardRef as ReactComponent };